import React from 'react'
import Container from '@material-ui/core/Container';
import imgHero from '../../assets/galerials2.jpg';
import imgHero2 from '../../assets/galerials3.jpg';
import imgHero3 from '../../assets/galerials5.jpg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from "swiper";
import "swiper/css/effect-fade";



const Hero = () => {
  
  return (
    <div className='hero'>
        <Container className='relative flex flexCenter flexCol'>
        <Swiper
                spaceBetween={30}
                effect={"fade"}
                autoplay={{
                  delay: 4500,
                  disableOnInteraction: false,
                }}
                modules={[EffectFade, Autoplay]}
                className="heroSlider"
              >
                <SwiperSlide>
                  <img src={imgHero} alt="Hero 1" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={imgHero2} alt="Hero 2" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={imgHero3} alt="Hero 3" />
                </SwiperSlide>
                
              </Swiper>

        </Container>
    </div>
  )
}

export default Hero